module.exports = __webpack_public_path__ + "img/chemical01.a0eb1757.png";